import map from 'lodash/map';
import {Popup} from 'semantic-ui-react';
import React from 'react';
import PriceIcon from '../icons/price';
import ColorIcon from '../icons/color';

export const getColumns = ({
  getUniqueValuesByField,
  vehicles,
  onChangeSelectFamily,
  renderOption,
  onChangeSelectState,
  renderOptionState,
  handleClickColors,
  handleClickPriceColors,
  loading,
}) => {
  return [
    {
      'Header': 'SFX',
      'accessor': 'sfx',
      'width': 150,
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'masterCode',
      'width': 200,
    },

    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': 'FAMILIA MODELO',
      'accessor': 'commercialName',
      'Cell': (cell) => {
        const id = cell.row.original.commercialName || '';
        const uniqueVehicles = getUniqueValuesByField(vehicles, 'name');
        return (
          <select className="select-vehicles-maintenance"
            onChange={(e) => onChangeSelectFamily(e, cell.row)}
            value={id}
          >
            <option value="">SELECCIONE</option>
            {map(uniqueVehicles, (vehicle) => renderOption(vehicle))}
          </select>
        );
      },
      'Filter': ({
        'column': {filterValue, setFilter},
      }) => {
        const uniqueVehicles = getUniqueValuesByField(vehicles, 'name');
        return (
          <select
            style={{'marginRight': '15px'}}
            className="select-vehicles-maintenance"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          >
            <option value="">TODOS</option>
            {map(uniqueVehicles, (vehicle) => renderOption(vehicle))}
          </select>
        );
      },
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'width': 150,
      'Cell': (cell) => {
        const status = cell.row.original.status;
        return (
          <select
            className="select-vehicles-maintenance"
            onChange={(e) => onChangeSelectState(e, cell.row)}
            value={status}
          >
            {renderOptionState()}
          </select>
        );
      },

      'Filter': ({
        'column': {filterValue, setFilter},
      }) => {
        return (
          <select
            style={{'marginRight': '15px'}}
            className="select-vehicles-maintenance"
            value={filterValue}
            onChange={(e) => {
              setFilter(e.target.value || null);
            }}
          >
            <option value="">TODOS</option>
            {renderOptionState()}
          </select>
        );
      },
    },
    {
      'id': 'actions',
      'Header': 'Acciones',
      'width': 150,
      'Filter': () => {
        return null;
      },
      'Cell': ({cell}) => {
        return (
          <div className='table-columns__buttons'>
            <div
              onClick={() => handleClickColors(cell.row.values)}
              disabled={loading}
            >
              <Popup
                trigger={
                  <ColorIcon />
                }
                content='Ver Historial de Colores'
                position='top center'
                inverted
              />
            </div>
            <div className='table-columns__buttons-space' />
            <div
              onClick={() => handleClickPriceColors(cell.row)}
              disabled={loading}
            >
              <Popup
                trigger={
                  <PriceIcon />
                }
                content='Ver Precios'
                position='top center'
                inverted
              />
            </div>
          </div>
        );
      },
    },
  ];
};
